import React from 'react';
import { Link } from 'react-router-dom';
import { isExternalHeroActionPath, normalizeHeroActionPath } from '../storefrontHeroActions';

export default function HeroActionLink({ to, className, children }) {
  const path = normalizeHeroActionPath(to);
  if (!path) return null;

  if (isExternalHeroActionPath(path)) {
    const external = /^https?:/i.test(path);
    return (
      <a
        href={path}
        className={className}
        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={path} className={className}>
      {children}
    </Link>
  );
}
